<script setup>
import CommentItem from './CommentItem.vue';

defineProps({
  comments: {
    type: Array,
    required: true,
  },
  hasMore: {
    type: Boolean,
    default: false,
  },
  isLoadingMore: {
    type: Boolean,
    default: false,
  },
  activeProfileUuid: {
    type: String,
    default: null,
  },
  personPanelId: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['load-more', 'delete', 'update', 'person-click']);

const handlePersonClick = (uuid, buttonEl) => {
  emit('person-click', uuid, buttonEl);
};

const handleLoadMore = () => {
  emit('load-more');
};

const handleDelete = commentUuid => {
  emit('delete', commentUuid);
};

const handleUpdate = payload => {
  emit('update', payload);
};
</script>

<template>
  <div v-if="comments.length" class="view-tray-modal__comments-list">
    <CommentItem
      v-for="comment in comments"
      :key="comment.uuid"
      :comment="comment"
      :active-profile-uuid="activeProfileUuid"
      :person-panel-id="personPanelId"
      @delete="handleDelete"
      @update="handleUpdate"
      @person-click="handlePersonClick"
    />

    <button
      v-if="hasMore"
      type="button"
      class="view-tray-modal__load-more"
      :disabled="isLoadingMore"
      @click="handleLoadMore"
    >
      {{ isLoadingMore ? 'Loading...' : 'Load more comments' }}
    </button>
  </div>
</template>
